/**
 * Light-on-light section boundary.
 *
 * A 1px rule at content width that fades to transparent at both ends — never a
 * full-bleed border. Sits at the top of the following light section.
 */
export function SectionHairline({
  /** Set false when the parent already applies the container and gutters. */
  inset = true,
  className = "",
}: {
  inset?: boolean;
  className?: string;
}) {
  const rule = <div className={`h-px bg-hairline-fade ${className}`} />;

  return inset ? (
    <div className="mx-auto max-w-container px-section-x">{rule}</div>
  ) : (
    rule
  );
}
